module.exports = __webpack_public_path__ + "img/juan.6c363518.png";